'use client'

import { useContext } from 'react'
import { useStore } from 'zustand'

import { CallArrangementContext } from '@/features/common-requests/call-arrangement-context'
import QuizCallArrangement from '@/features/common-requests/QuizCallArrangement'
import { ConsultationRequestFormContext } from './ConsultationRequestFormProvider'

export default function ConsultationCallArrangementStage() {
  const store = useContext(CallArrangementContext)
  const requestStore = useContext(ConsultationRequestFormContext)
  if (!store)
    throw new Error(
      'ConsultationCallArrangementStage must be used within a CallArrangementContext',
    )
  if (!requestStore)
    throw new Error(
      'ConsultationCallArrangementStage must be used within a ConsultationRequestFormContext',
    )

  const availableDates = useStore(store, (state) => state.availableDates)
  const selectedSchedule = useStore(store, (state) => state.selectedSchedule)
  const immediateSlotAvailable = useStore(
    store,
    (state) => state.immediateSlotAvailable,
  )
  const onSelectSchedule = useStore(store, (state) => state.onSelectSchedule)
  const onNext = useStore(store, (state) => state.onNext)
  const onPrev = useStore(requestStore, (state) => state.onPrev)
  const currentStageIdx = useStore(
    requestStore,
    (state) => state.currentStageIdx,
  )
  const totalSteps = useStore(requestStore, (state) => state.stages.length)

  return (
    <QuizCallArrangement
      availableDates={availableDates}
      currentStep={currentStageIdx + 1}
      immediateSlotAvailable={immediateSlotAvailable}
      mobileServiceLabel="Request care · Consultation"
      onBack={onPrev}
      onNext={onNext}
      onSelectSchedule={onSelectSchedule}
      selectedSchedule={selectedSchedule}
      serviceLabel="Request care · General consultation"
      totalSteps={totalSteps}
    />
  )
}
